<template>
    <div>
        <Form :items="robotItems" :formData="formData">
            <span slot="footer"></span>
        </Form>
        <div class="footer">
            <el-button round type="primary" @click="submit">{{ $t("zhiji.common.save") }}</el-button>
        </div>
    </div>
</template>

<script>
import Form from "@/views/zhiji/components/form/Form";

export default {
    components: {
        Form
    },
    props: ["value"],
    data() {
        return {
            robotItems: [
                {
                    name: "source",
                    label: "渠道",
                    type: "ArrayInput",
                    extendProps: {
                        placeholder: "请输入渠道"
                    }
                }
            ],
            formData: this.value
        };
    },
    watch: {
        value() {
            this.formDatas = this.value;
        }
    },
    methods: {
        submit() {
            this.$emit("submit", this.formDatas);
        }
    }
};
</script>

<style scoped>
.footer {
    display: flex;
    justify-content: flex-end;
}
</style>
